import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '../../assets/img/exam-title.png'


const _hoisted_1 = { class: "status-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "status-title",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "status-content" }
const _hoisted_4 = {
  key: 0,
  class: "status-content-desc"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 2022年四川省新媒体应用技能大赛线上考试 ")
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 未开始 ")
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 考试时间： ")
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 2022年11月5日（周六）8:00～20:00 ")
const _hoisted_13 = {
  key: 1,
  class: "status-content-desc"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 2022年四川省新媒体应用技能大赛线上考试 ")
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 已经结束 ")
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShareBtn = _resolveComponent("ShareBtn")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_ctx.type === '0')
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            _hoisted_12
          ]))
        : _createCommentVNode("", true),
      (_ctx.type === '1')
        ? (_openBlock(), _createBlock("div", _hoisted_13, [
            _hoisted_14,
            _hoisted_15,
            _hoisted_16,
            _hoisted_17,
            _hoisted_18
          ]))
        : _createCommentVNode("", true),
      _hoisted_19,
      _hoisted_20,
      _createVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.returnHome()))
      }, "返回首页")
    ]),
    _createVNode(_component_ShareBtn)
  ]))
}